/**
 * Product thumbnail (§Task3) — shows the line's product/variant image for visual
 * item confirmation (drawer + pack flow). Falls back to a neutral box-icon tile
 * when the URL is absent OR fails to load (broken/expired CDN link), so a missing
 * image never leaves a broken-image glyph.
 */
import { useState } from "react";
import { Icon } from "./Icon.js";

export function Thumb({ src, alt, size = 40 }: { src?: string | null; alt?: string; size?: number }) {
  const [failed, setFailed] = useState(false);
  const style = { width: size, height: size };
  if (!src || failed) {
    return (
      <span className="thumb thumb--empty" style={style} aria-hidden="true">
        <Icon name="box" size={Math.round(size * 0.5)} />
      </span>
    );
  }
  return (
    <img
      className="thumb"
      style={style}
      src={src}
      alt={alt ?? ""}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
}
